<template>
    <Head :title="dashboard_title" />
    <!-- No LeftSidebarLayout: the dashboards have their own side nav, so the full layout
         renders a double sidebar. The slim top bar alone carries the way back (BUG-1144). -->
    <div class="flex h-dvh flex-col bg-surface">
        <header class="flex items-center gap-3 border-b border-border px-4 py-2">
            <BaseButton theme="neutral" size="sm" class="flex items-center gap-1" data-testid="vercel-dashboard-back-button" @click="goHome">
                <i class="bi bi-chevron-left" aria-hidden="true"></i>
                <span class="body-small">{{ t("pages.vercelDashboard.backToNadia") }}</span>
            </BaseButton>
            <h1 class="body-small-semibold truncate text-ink">{{ dashboard_title }}</h1>
        </header>
        <!-- The proxied app owns this iframe (its document is not Inertia), so it fills the
             page rather than participating in layout. The load event fires on any served
             response, including an upstream error page, which is why there is no timeout. -->
        <div class="relative min-h-0 grow">
            <iframe :src="embed_url" :title="dashboard_title" class="absolute inset-0 h-full w-full border-0" @load="iframeLoaded = true" />
            <div v-if="!iframeLoaded" class="absolute inset-0 bg-surface">
                <OrbitingParticles :aria-label="t('pages.vercelDashboard.loading')" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { Head } from "@inertiajs/vue3";
import BaseButton from "~vue/components/BaseButton.vue";
import OrbitingParticles from "~vue/components/OrbitingParticles.vue";
import { isInIFrame, openUrl } from "~vue/utils";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps<{
    dashboard_title: string;
    embed_url: string;
    home_url: string;
}>();

const iframeLoaded = ref(false);

const goHome = () => {
    openUrl(isInIFrame() ? `${props.home_url}?client=teams` : props.home_url);
};
</script>
